import api from "./api.js";

export default class NoticeApi {
  static async create(data) {
    return await api.post(`notice`, data);
  }
  static async getList(params) {
    return await api.get(`notice`, params);
  }
  static async getById(noticeId, params) {
    return await api.get(`notice/${noticeId}`, params);
  }
  static async update(noticeId, data) {
    return await api.put(`notice/${noticeId}`, data);
  }
  static async delete(data) {
    return await api.del(`notice`, data);
  }
}
